import { DraftItemBelow, PublishedItemBelow, ScheduleItemBelow } from "slot-definitions"
import { TagList } from "routes/schedule/plugins/baskets/tags/schedule-tree-tags/tag-list"

ScheduleItemBelow.plug(<TagList />)
DraftItemBelow.plug(<TagList />)
PublishedItemBelow.plug(<TagList />)
